import { FaShieldAlt, FaStar, FaUserShield } from 'react-icons/fa';

const homeConfig = {
    certifications: [
        {
            title: "Licensed & Insured",
            icon: <FaShieldAlt />,
            description: "Full coverage for your peace of mind"
        },
        {
            title: "BBB A+ Rated",
            icon: <FaStar />,
            description: "Top-rated service provider"
        },
        {
            title: "Certified Experts",
            icon: <FaUserShield />,
            description: "Professional team of specialists"
        }
    ],
    // Add other configurations as needed
};

export default homeConfig; 